var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgILocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.664062C3.13287 0.664062 0 3.79693 0 7.66406C0 9.1256 0.447552 10.4822 1.21678 11.6011C1.21678 11.6011 2.62238 13.741 7 18.4333C11.3846 13.748 12.7832 11.6011 12.7832 11.6011C13.5524 10.4822 14 9.11861 14 7.66406C14 3.79693 10.8671 0.664062 7 0.664062ZM7 10.5452C5.46853 10.5452 4.22378 9.30043 4.22378 7.76896C4.22378 6.23749 5.46853 4.99273 7 4.99273C8.53147 4.99273 9.77622 6.23749 9.77622 7.76896C9.77622 9.30043 8.53147 10.5452 7 10.5452Z",
    fill: "#3284FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgILocation);
export default __webpack_public_path__ + "static/media/i_location.c76dd90ec0e03baff02f9a438f5bbfda.svg";
export { ForwardRef as ReactComponent };